module.exports = __webpack_public_path__ + "img/9788996575535.dda2502e.jpg";